import { setPagination } from '../State/pagination';
import fetchSuppliers from '../Services/fetchSuppliers';

export default () => async (dispatch) => {
  dispatch(setPagination({ current: 1 }));
  dispatch(fetchSuppliers());
}
